import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import Element from 'element-ui'
import './assets/style/theme/element.scss'

import './assets/style/reset.scss'
import './assets/style/transition.scss'
import filters from './util/filters'
import i18n from './i18n/i18n'



Vue.use(Element)

import VueQrcode from '@chenfengyuan/vue-qrcode';

Vue.component(VueQrcode.name, VueQrcode);

import RouterBack from './components/RouterBack/index.vue'

Vue.component('router-back', RouterBack)

Date.prototype.Format = function (fmt) { // author: meizz
  var o = {
    "M+": this.getMonth() + 1, // 月份
    "d+": this.getDate(), // 日
    "h+": this.getHours(), // 小时
    "m+": this.getMinutes(), // 分
    "s+": this.getSeconds(), // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    "S": this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

import scroll from 'vue-seamless-scroll'

Vue.use(scroll)

Vue.config.productionTip = false

import {employeeRefresh, employeeModules} from '@/api/account/employee'
import {setToken, getToken} from '@/util/auth'
import axios from 'axios'

function getServerConfig () {
  return new Promise ((resolve, reject) => {
    axios.get('/static/config.json').then(data => {
      for (let key in data.data) {
        Vue.prototype['$'+key] = data.data[key];
      }
      resolve();
    }).catch(error => {
      console.log(error);
      reject()
    })
  })
}

Vue.prototype.$btnCheck = function (val) {
  return store.getters.buttons[val]
}

async function main() {
  await getServerConfig();
  // console.log('我的地址是' + Vue.prototype.$api)
  let vue = new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')




  let token = getToken()
  if (token) {
    employeeRefresh({token: getToken}).then(res => {
      if (res.code == 0) {
        setToken(res.refreshToken);
        vue.$store.dispatch('setEnterpriseEmployee', res.data)
        employeeModules().then(res => {
          if (res.code == 0) {
            res.data = res.data || []
            if (vue.$route.name == 'login') {
              if (res.data.length === 0) {
                vue.$message.warning('请联系管理员开通权限')
                return
              }
              vue.$router.replace({name: res.data[0].modules[0].webRouterName})
            }
            vue.$store.dispatch('setEnterpriseMenu', res.data)

          }
        })
      }
    })
  }
}

main()



